import UsageBlock from './views/Hint.c';
export default UsageBlock;
